Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _object_spread_props = require("@swc/helpers/_/_object_spread_props");
var require_logger = require('../utils/logger.cjs');
var require_tool = require('../utils/tool.cjs');
var require_load = require('../utils/load.cjs');
var require_context = require('../utils/context.cjs');
require('../utils/index.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
var _module_federation_error_codes = require("@module-federation/error-codes");
//#region src/module/index.ts
function createRemoteEntryInitOptions(remoteInfo, hostShareScopeMap, rawInitScope) {
    var localShareScopeMap = hostShareScopeMap;
    var shareScopeKeys = Array.isArray(remoteInfo.shareScope) ? remoteInfo.shareScope : [
        remoteInfo.shareScope
    ];
    if (!shareScopeKeys.length) shareScopeKeys.push("default");
    shareScopeKeys.forEach((shareScopeKey)=>{
        if (!localShareScopeMap[shareScopeKey]) localShareScopeMap[shareScopeKey] = {};
    });
    var remoteEntryInitOptions = {
        version: remoteInfo.version || "",
        shareScopeKeys: Array.isArray(remoteInfo.shareScope) ? shareScopeKeys : remoteInfo.shareScope || "default"
    };
    Object.defineProperty(remoteEntryInitOptions, "shareScopeMap", {
        value: localShareScopeMap,
        enumerable: false
    });
    return {
        remoteEntryInitOptions,
        shareScope: localShareScopeMap[shareScopeKeys[0]],
        initScope: rawInitScope ?? []
    };
}
var Module = /*#__PURE__*/ function() {
    "use strict";
    function Module(param) {
        var remoteInfo = param.remoteInfo, host = param.host;
        _class_call_check._(this, Module);
        this.inited = false;
        this.initing = false;
        this.lib = void 0;
        this.remoteInfo = remoteInfo;
        this.host = host;
    }
    _create_class._(Module, [
        {
            key: "getEntry",
            value: function getEntry() {
                return _async_to_generator._(function*() {
                    if (this.remoteEntryExports) return this.remoteEntryExports;
                    var remoteEntryExports = yield require_load.getRemoteEntry({
                        origin: this.host,
                        remoteInfo: this.remoteInfo,
                        remoteEntryExports: this.remoteEntryExports
                    });
                    require_logger.assert(remoteEntryExports, `remoteEntryExports is undefined \n ${(0, _module_federation_sdk.safeToString)(this.remoteInfo)}`);
                    this.remoteEntryExports = remoteEntryExports;
                    return this.remoteEntryExports;
                }).call(this);
            }
        },
        {
            key: "init",
            value: function init(id, remoteSnapshot, rawInitScope) {
                return _async_to_generator._(function*() {
                    var remoteEntryExports = yield this.getEntry();
                    if (this.inited) return remoteEntryExports;
                    if (this.initPromise) {
                        yield this.initPromise;
                        return remoteEntryExports;
                    }
                    this.initing = true;
                    this.initPromise = (()=>_async_to_generator._(function*() {
                            var _createRemoteEntryInitOptions = createRemoteEntryInitOptions(this.remoteInfo, this.host.shareScopeMap, rawInitScope), remoteEntryInitOptions = _createRemoteEntryInitOptions.remoteEntryInitOptions, shareScope = _createRemoteEntryInitOptions.shareScope, initScope = _createRemoteEntryInitOptions.initScope;
                            var initContainerOptions = yield this.host.hooks.lifecycle.beforeInitContainer.emit({
                                shareScope,
                                remoteEntryInitOptions,
                                initScope,
                                remoteInfo: this.remoteInfo,
                                origin: this.host
                            });
                            if (typeof (remoteEntryExports === null || remoteEntryExports === void 0 ? void 0 : remoteEntryExports.init) === "undefined") require_logger.error(_module_federation_error_codes.RUNTIME_002, _module_federation_error_codes.runtimeDescMap, {
                                hostName: this.host.name,
                                remoteName: this.remoteInfo.name,
                                remoteEntryUrl: this.remoteInfo.entry,
                                remoteEntryKey: this.remoteInfo.entryGlobalName
                            }, void 0, require_context.optionsToMFContext(this.host.options));
                            yield remoteEntryExports.init(initContainerOptions.shareScope, initContainerOptions.initScope, initContainerOptions.remoteEntryInitOptions);
                            yield this.host.hooks.lifecycle.initContainer.emit(_object_spread_props._(_object_spread._({}, initContainerOptions), {
                                id,
                                remoteSnapshot,
                                remoteEntryExports
                            }));
                            this.inited = true;
                        }).call(this))();
                    try {
                        yield this.initPromise;
                    } finally{
                        this.initing = false;
                        this.initPromise = void 0;
                    }
                    return remoteEntryExports;
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(id, expose, options, remoteSnapshot) {
                return _async_to_generator._(function*() {
                    var _ref = options || {
                        loadFactory: true
                    }, _ref_loadFactory = _ref.loadFactory, loadFactory = _ref_loadFactory === void 0 ? true : _ref_loadFactory;
                    var remoteEntryExports = yield this.init(id, remoteSnapshot);
                    this.lib = remoteEntryExports;
                    var moduleFactory;
                    moduleFactory = yield this.host.loaderHook.lifecycle.getModuleFactory.emit({
                        remoteEntryExports,
                        expose,
                        moduleInfo: this.remoteInfo
                    });
                    if (!moduleFactory) moduleFactory = yield remoteEntryExports.get(expose);
                    require_logger.assert(moduleFactory, `${require_tool.getFMId(this.remoteInfo)} remote don't export ${expose}.`);
                    var symbolName = require_tool.processModuleAlias(this.remoteInfo.name, expose);
                    var wrapModuleFactory = this.wraperFactory(moduleFactory, symbolName);
                    if (!loadFactory) return wrapModuleFactory;
                    return yield wrapModuleFactory();
                }).call(this);
            }
        },
        {
            key: "wraperFactory",
            value: function wraperFactory(moduleFactory, id) {
                function defineModuleId(res, id) {
                    if (res && typeof res === "object" && Object.isExtensible(res) && !Object.getOwnPropertyDescriptor(res, Symbol.for("mf_module_id"))) Object.defineProperty(res, Symbol.for("mf_module_id"), {
                        value: id,
                        enumerable: false
                    });
                }
                if (moduleFactory instanceof Promise) return ()=>_async_to_generator._(function*() {
                        var res = yield moduleFactory();
                        defineModuleId(res, id);
                        return res;
                    })();
                else return ()=>{
                    var res = moduleFactory();
                    defineModuleId(res, id);
                    return res;
                };
            }
        }
    ]);
    return Module;
}();
//#endregion
exports.Module = Module; //# sourceMappingURL=index.cjs.map
